var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_2484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.5C5.88325 24.5 0.5 19.1167 0.5 12.5C0.5 5.88325 5.88325 0.5 12.5 0.5C19.1167 0.5 24.5 5.88325 24.5 12.5C24.5 19.1167 19.1167 24.5 12.5 24.5ZM12.5 2C6.71025 2 2 6.71025 2 12.5C2 18.2897 6.71025 23 12.5 23C18.2897 23 23 18.2897 23 12.5C23 6.71025 18.2897 2 12.5 2ZM16.25 11C15.4228 11 14.75 10.3272 14.75 9.5C14.75 8.67275 15.4228 8 16.25 8C17.0772 8 17.75 8.67275 17.75 9.5C17.75 10.3272 17.0772 11 16.25 11ZM8.75 11C7.92275 11 7.25 10.3272 7.25 9.5C7.25 8.67275 7.92275 8 8.75 8C9.57725 8 10.25 8.67275 10.25 9.5C10.25 10.3272 9.57725 11 8.75 11ZM17.75 16.25C17.75 16.0511 17.671 15.8603 17.5303 15.7197C17.3897 15.579 17.1989 15.5 17 15.5H8C7.80109 15.5 7.61032 15.579 7.46967 15.7197C7.32902 15.8603 7.25 16.0511 7.25 16.25C7.25 16.4489 7.32902 16.6397 7.46967 16.7803C7.61032 16.921 7.80109 17 8 17H17C17.1989 17 17.3897 16.921 17.5303 16.7803C17.671 16.6397 17.75 16.4489 17.75 16.25Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_2484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEmoji);
export default __webpack_public_path__ + "static/media/sadEmoji.59c62fb15647f248290495d4cdaa12eb.svg";
export { ForwardRef as ReactComponent };